<template>
  <div class="band pushFooter">
    <div class="splitColumns">
      <div class="column67 guideContent">
        <div>
          For a full list of updates, see the <a href="https://docs.rstudio.com/rspm/news">release notes</a>
        </div>
        <hr>
        <WhatsNewItem
          v-for="w in getNewItems"
          :key="w.id"
          :whats-new-item="w"
        />
        <div
          v-if="showGetOlder"
          style="text-align: center;"
        >
          <div>
            <button
              data-automation="olderItemsBtn"
              @click="show += 2"
            >
              Show older items
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import WhatsNewItem from './WhatsNewItem'
import NEWS_ITEMS from '../constants/news-items'
import * as types from '../store/mutation-types'

export default {
  name: 'WhatsNew',
  components: {
    WhatsNewItem,
  },
  data: () => {
    return { show: 2 }
  },
  computed: {
    getNewItems: function () {
      return NEWS_ITEMS.slice().reverse().slice(0, this.show)
    },
    // While there are more items to show
    showGetOlder: function () {
      if (this.show < NEWS_ITEMS.length) {
        return true
      }
      return false
    },
  },
  mounted: function () {
    this.$store.commit(types.SET_LATEST_VERSION_UPDATE_SEEN, NEWS_ITEMS[NEWS_ITEMS.length - 1].release)
    this.$store.commit(types.SET_CURRENT_NAV, 'whatsNew')
  },
}

</script>
